import { render, staticRenderFns } from "./NotificationRecurringOrderProductNotActiveModal.vue?vue&type=template&id=03c28310&"
import script from "./NotificationRecurringOrderProductNotActiveModal.vue?vue&type=script&lang=js&"
export * from "./NotificationRecurringOrderProductNotActiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports